<b>If you continue the following data will be overwritten for this existing patient. Please review this information and be sure you have identified the correct patient!</b>
<kendo-splitter [style.margin-top.px]="10" orientation="horizontal" class="my-splitter">
  <kendo-splitter-pane size="40%" class="left-pane">
    <div [style.padding.px]="10" class="column">
      <p>Demographic Differences: </p>
      @if (PatientSearchUtil.compareStrings(newPatientSearch.fname, newPatientMatch.fname, false) === 'mismatch') {
        <div [style.margin-top.px]="10" class="rounded-box">
          <div class="row-wrap" [style.gap.px]="5">
            <b>First Name: </b>
            @if (newPatientMatch.fname.length > 0) {
              <p [ngClass]="fnameChecked === false ? 'strikethrough' : 'selected'"> {{newPatientMatch.fname}}</p>
            }
            @if (newPatientMatch.fname.length === 0) {
              <p> Missing</p>
            }
            @if (newPatientSearch.fname.length === 0 && !fnameChecked) {
              <p> --> Missing</p>
            }
            @if (newPatientSearch.fname.length > 0 && !fnameChecked) {
              <p  class="selected"> --> {{newPatientSearch.fname}}</p>
            }
          </div>
          <kendo-label>
            Keep Existing Value
            <kendo-switch [(ngModel)]="genderChecked" (valueChange)="onGenderChange($event)"></kendo-switch>
          </kendo-label>
        </div>
      }
      @if (PatientSearchUtil.compareStrings(newPatientSearch.mname, newPatientMatch.mname, false) === 'mismatch') {
        <div [style.margin-top.px]="10" class="rounded-box">
          <div class="row-wrap" [style.gap.px]="5">
            <p><b>Middle Name:</b>&nbsp;</p>
            @if (newPatientMatch.mname.length > 0) {
              <p [ngClass]="mnameChecked === false ? 'strikethrough' : 'selected'">{{newPatientMatch.mname}}</p>
            }
            @if (newPatientMatch.mname.length === 0) {
              <p>Missing</p>
            }
            @if (newPatientSearch.mname.length === 0 && !mnameChecked) {
              <p>--> Missing</p>
            }
            @if (newPatientSearch.mname.length > 0 && !mnameChecked) {
              <p  class="selected">--> {{newPatientSearch.mname}}</p>
            }
          </div>
          <kendo-label>
            Keep Existing Value
            <kendo-switch [(ngModel)]="mnameChecked" (valueChange)="onMnameChange($event)"></kendo-switch>
          </kendo-label>
        </div>
      }
      @if (PatientSearchUtil.compareStrings(newPatientSearch.lname, newPatientMatch.lname, false) === 'mismatch') {
        <div [style.margin-top.px]="10" class="rounded-box">
          <div class="row-wrap" [style.gap.px]="5">
            <p><b>Last Name:</b>&nbsp;</p>
            @if (newPatientMatch.lname.length > 0) {
              <p [ngClass]="lnameChecked === false ? 'strikethrough' : 'selected'">{{newPatientMatch.lname}}</p>
            }
            @if (newPatientMatch.lname.length === 0) {
              <p>Missing</p>
            }
            @if (newPatientSearch.lname.length === 0 && !lnameChecked) {
              <p>--> Missing</p>
            }
            @if (newPatientSearch.lname.length > 0 && !lnameChecked) {
              <p  class="selected">--> {{newPatientSearch.lname}}</p>
            }
          </div>
          <kendo-label>
            Keep Existing Value
            <kendo-switch [(ngModel)]="lnameChecked" (valueChange)="onLnameChange($event)"></kendo-switch>
          </kendo-label>
        </div>
      }
      @if (PatientSearchUtil.compareStrings(newPatientSearch.suffix, newPatientMatch.suffix, false) === 'mismatch') {
        <div [style.margin-top.px]="10" class="rounded-box">
          <div class="row-wrap" [style.gap.px]="5">
            <p><b>Suffix:</b>&nbsp;</p>
            @if (newPatientMatch.suffix.length > 0) {
              <p [ngClass]="suffixChecked === false ? 'strikethrough' : 'selected'">{{newPatientMatch.suffix}}</p>
            }
            @if (newPatientMatch.suffix.length === 0) {
              <p>Missing</p>
            }
            @if (newPatientSearch.suffix.length === 0 && !suffixChecked) {
              <p>--> Missing</p>
            }
            @if (newPatientSearch.suffix.length > 0 && !suffixChecked) {
              <p  class="selected">--> {{newPatientSearch.suffix}}</p>
            }
          </div>
          <kendo-label>
            Keep Existing Value
            <kendo-switch [(ngModel)]="suffixChecked" (valueChange)="onSuffixChange($event)"></kendo-switch>
          </kendo-label>
        </div>
      }
      @if (PatientSearchUtil.compareStrings(newPatientSearch.dob, newPatientMatch.dob, true) === 'mismatch') {
        <div [style.margin-top.px]="10" class="rounded-box">
          <div class="row-wrap" [style.gap.px]="5">
            <p><b>DOB:</b>&nbsp;</p>
            @if (newPatientMatch.dob.length > 0) {
              <p [ngClass]="dobChecked === false ? 'strikethrough' : 'selected'">{{newPatientMatch.dob | convertDob}}</p>
            }
            @if (newPatientMatch.dob.length === 0) {
              <p>Missing</p>
            }
            @if (newPatientSearch.dob.length === 0 && !dobChecked) {
              <p>--> Missing</p>
            }
            @if (newPatientSearch.dob.length > 0 && !dobChecked) {
              <p  class="selected">--> {{newPatientSearch.dob | convertDob}}</p>
            }
          </div>
          <kendo-label>
            Keep Existing Value
            <kendo-switch [(ngModel)]="dobChecked" (valueChange)="onDobChange($event)"></kendo-switch>
          </kendo-label>
        </div>
      }
      @if (PatientSearchUtil.compareStrings(newPatientSearch.gender, newPatientMatch.gender, false) === 'mismatch') {
        <div [style.margin-top.px]="10" class="rounded-box">
          <div class="row-wrap" [style.gap.px]="5">
            <b>Gender: </b>
            @if (newPatientMatch.gender.length > 0) {
              <p [ngClass]="genderChecked === false ? 'strikethrough' : 'selected'"> {{newPatientMatch.gender | genderPipe}}</p>
            }
            @if (newPatientMatch.gender.length === 0) {
              <p> Missing</p>
            }
            @if (newPatientSearch.gender.length === 0 && !genderChecked) {
              <p> --> Missing</p>
            }
            @if (newPatientSearch.gender.length > 0 && !genderChecked) {
              <p  class="selected"> --> {{newPatientSearch.gender | genderPipe}}</p>
            }
          </div>
          <kendo-label>
            Keep Existing Value
            <kendo-switch [(ngModel)]="genderChecked" (valueChange)="onGenderChange($event)"></kendo-switch>
          </kendo-label>
        </div>
      }
      @if (PatientSearchUtil.compareStrings(newPatientSearch.street, newPatientMatch.street, false) === 'mismatch') {
        <div [style.margin-top.px]="10" class="rounded-box">
          <div class="row-wrap" [style.gap.px]="5">
            <p><b>Street:</b>&nbsp;</p>
            @if (newPatientMatch.street.length > 0) {
              <p [ngClass]="streetChecked === false ? 'strikethrough' : 'selected'">{{newPatientMatch.street}}</p>
            }
            @if (newPatientMatch.street.length === 0) {
              <p>Missing</p>
            }
            @if (newPatientSearch.street.length === 0 && !streetChecked) {
              <p>--> Missing</p>
            }
            @if (newPatientSearch.street.length > 0 && !streetChecked) {
              <p  class="selected">--> {{newPatientSearch.street}}</p>
            }
          </div>
          <kendo-label>
            Keep Existing Value
            <kendo-switch [(ngModel)]="streetChecked"  (valueChange)="onStreetChange($event)"></kendo-switch>
          </kendo-label>
        </div>
      }
      @if (PatientSearchUtil.compareStrings(newPatientSearch.city, newPatientMatch.city, false) === 'mismatch') {
        <div [style.margin-top.px]="10" class="rounded-box">
          <div class="row-wrap" [style.gap.px]="5">
            <p><b>City:</b>&nbsp;</p>
            @if (newPatientMatch.city.length > 0) {
              <p  [ngClass]="cityChecked === false ? 'strikethrough' : 'selected'">{{newPatientMatch.city}}</p>
            }
            @if (newPatientMatch.city.length === 0) {
              <p>Missing</p>
            }
            @if (newPatientSearch.city.length === 0 && !cityChecked) {
              <p>--> Missing</p>
            }
            @if (newPatientSearch.city.length > 0 && !cityChecked) {
              <p  class="selected">--> {{newPatientSearch.city}}</p>
            }
          </div>
          <kendo-label>
            Keep Existing Value
            <kendo-switch [(ngModel)]="cityChecked"  (valueChange)="onCityChange($event)"></kendo-switch>
          </kendo-label>
        </div>
      }
      @if (PatientSearchUtil.compareStrings(newPatientSearch.state, newPatientMatch.state, false) === 'mismatch') {
        <div [style.margin-top.px]="10" class="rounded-box">
          <div class="row-wrap" [style.gap.px]="5">
            <p><b>State:</b>&nbsp;</p>
            @if (newPatientMatch.state.length > 0) {
              <p [ngClass]="stateChecked === false ? 'strikethrough' : 'selected'">{{newPatientMatch.state}}</p>
            }
            @if (newPatientMatch.state.length === 0) {
              <p>Missing</p>
            }
            @if (newPatientSearch.state.length === 0 && !stateChecked) {
              <p>--> Missing</p>
            }
            @if (newPatientSearch.state.length > 0 && !stateChecked) {
              <p  class="selected">--> {{newPatientSearch.state}}</p>
            }
          </div>
          <kendo-label>
            Keep Existing Value
            <kendo-switch [(ngModel)]="stateChecked"  (valueChange)="onStateChange($event)"></kendo-switch>
          </kendo-label>
        </div>
      }
      @if (PatientSearchUtil.compareStrings(newPatientSearch.zip, newPatientMatch.zip, false) === 'mismatch') {
        <div [style.margin-top.px]="10" class="rounded-box">
          <div class="row-wrap" [style.gap.px]="5">
            <p><b>Zip:</b>&nbsp;</p>
            @if (newPatientMatch.zip.length > 0) {
              <p [ngClass]="zipChecked === false ? 'strikethrough' : 'selected'">{{newPatientMatch.zip}}</p>
            }
            @if (newPatientMatch.zip.length === 0) {
              <p>Missing</p>
            }
            @if (newPatientSearch.zip.length === 0 && !zipChecked) {
              <p>--> Missing</p>
            }
            @if (newPatientSearch.zip.length > 0 && !zipChecked) {
              <p  class="selected">--> {{newPatientSearch.zip}}</p>
            }
          </div>
          <kendo-label>
            Keep Existing Value
            <kendo-switch [(ngModel)]="zipChecked"  (valueChange)="onZipChange($event)"></kendo-switch>
          </kendo-label>
        </div>
      }
      @if (PatientSearchUtil.compareStrings(newPatientSearch.phone, newPatientMatch.phone, false) === 'mismatch') {
        <div [style.margin-top.px]="10" class="rounded-box">
          <div class="row-wrap" [style.gap.px]="5">
            <p><b>Phone:</b>&nbsp;</p>
            @if (newPatientMatch.phone.length > 0) {
<!--              | phoneFormat-->
              <p [ngClass]="phoneChecked === false ? 'strikethrough' : 'selected'">{{newPatientMatch.phone}}</p>
            }
            @if (newPatientMatch.phone.length === 0) {
              <p>Missing</p>
            }
            @if (newPatientSearch.phone.length === 0 && !phoneChecked) {
              <p>--> Missing</p>
            }
            @if (newPatientSearch.phone.length > 0 && !phoneChecked) {
<!--              | phoneFormat-->
              <p  class="selected">--> {{newPatientSearch.phone}}</p>
            }
          </div>
          <kendo-label>
            Keep Existing Value
            <kendo-switch [(ngModel)]="phoneChecked" (valueChange)="onPhoneChange($event)"></kendo-switch>
          </kendo-label>
        </div>
      }
    </div>
  </kendo-splitter-pane>
  <kendo-splitter-pane [style.padding.px]="10" [scrollable]="false" class="column right-pane">
    <div class="center-center column">
      <kendo-card [width]="'500px'">
        <kendo-card-header>Updated Patient Information</kendo-card-header>
        <kendo-card-body>
          <div class="column">
            <div class="margin-top-10">
              <p><b>Name:</b> {{reviewedPatient.fname}} {{reviewedPatient.mname}} {{reviewedPatient.lname}} {{reviewedPatient.suffix}}</p>
            </div>
            <div class="margin-top-10">
              <p><b>Address:</b> {{reviewedPatient.street !== null ? reviewedPatient.street : ''}}
              {{reviewedPatient.city !== null ? reviewedPatient.city : ''}}
            {{reviewedPatient.state !== undefined ? reviewedPatient.state : ''}} {{reviewedPatient.zip !== null ? reviewedPatient.zip : ''}}</p>
          </div>
          <div class="margin-top-10">
<!--            | phoneFormat-->
            <p><b>Phone:</b> {{reviewedPatient.phone !== null ? (reviewedPatient.phone) : ''}}</p>
          </div>
          <div class="margin-top-10">
            <p><b>DOB:</b> {{reviewedPatient.dob !== null ? (reviewedPatient.dob | convertDob) : ''}}</p>
          </div>
          <div class="margin-top-10">
            <p><b>Gender:</b> {{reviewedPatient.gender !== null ? (reviewedPatient.gender | genderPipe) : ''}}</p>
          </div>
        </div>
      </kendo-card-body>
    </kendo-card>
    <div class="column full-width" [style.padding.px]="20">
      <button kendoButton themeColor="primary" class="full-width" (click)="confirm()" [style.margin-top.px]="10">Finish & Continue</button>
      <button kendoButton themeColor="error" class="full-width" (click)="markAsInvalid('upload-error')" [style.margin-top.px]="10" fillMode="outline">Mark Upload Error & Close</button>
      <button kendoButton themeColor="warning" class="full-width" (click)="markAsInvalid('repeat-upload')" [style.margin-top.px]="10" fillMode="outline">Mark Repeat Upload & Close</button>
      <button kendoButton themeColor="error" class="full-width" (click)="close()" [style.margin-top.px]="10">Close</button>-
      <!--                <div [style.margin-top.px]="10" [style.gap.px]="10" class="row-wrap full-width">-->
      <!--                    <button kendoButton themeColor="error" (click)="close()">Close</button>-->
      <!--                    <button kendoButton (click)="confirm()" themeColor="primary">Finish</button>-->
    <!--                </div>-->
    <!--                <div [style.margin-top.px]="10" [style.gap.px]="10" class="row-wrap full-width">-->
    <!--                    <button kendoButton themeColor="error" (click)="close()">Close</button>-->
    <!--                    <button kendoButton (click)="confirm()" themeColor="primary">Finish</button>-->
  <!--                </div>-->
</div>
</div>
</kendo-splitter-pane>
</kendo-splitter>
